import { connect } from "react-redux";
import List from "../../../common/list";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import { AccessScopeConstants } from "../../../../constants";
import * as ListCellRenders from "../../../common/list/ListCellRenders";

export const AudienceAssignmentList = ({
  assignments,
  id,
  user,
  onDeleteAssignmentAction,
}) => {
  const { role } = user || {};
  // The API checks User access Delete to remove an assignment
  // (AudienceController.Delete), not Content access Update (P-UI-7).
  const canDelete = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.UserAccess,
    AccessScopeConstants.DeleteScope
  );

  return (
    <List
      data={assignments}
      pagination={false}
      selectionMode=""
      totalRecords={assignments.length || 0}
      columns={[
        {
          field: "learningPathwayName",
          header: "learning_program_name",
        },
        {
          field: "isOptional",
          header: "training_type",
          sortable: false,
          body: ListCellRenders.TrainingType,
        },
        {
          field: "startDate",
          header: "start_date",
          body: ListCellRenders.AssignmentStartDate,
        },
        {
          field: "endDate",
          header: "end_date",
          body: ListCellRenders.AssignmentEndDate,
        },
        {
          field: "relativeEndInDays",
          header: "relative_end_days",
          sortable: false,
          body: (rowData) =>
            rowData?.isOptional ? "-" : rowData?.relativeEndInDays,
        },
        {
          field: "actions",
          headerIcon: "pi-cog",
          align: "center",
          body: ListCellRenders.OtherActions([
            {
              label: "delete",
              icon: "pi-trash",
              isAllowed: canDelete,
              action: (data) => onDeleteAssignmentAction(data),
            },
          ]),
        },
      ]}
    />
  );
};

const mapStateToProps = (state) => ({
  assignments: state.audiences.record?.assignments || [],
});

export default connect(mapStateToProps)(AudienceAssignmentList);
